<template>
  <div>
    <v-dialog
      v-model="dialog"
      :max-width="options.width"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card>
        <v-container class="px-10 pt-8">
          <p class="subtitle-1 font-weight-bold">Update Email</p>
          <v-form v-model="form">
            <v-row>
              <v-col class="py-0" cols="12" sm="12" md="12">
                <v-text-field
                  v-model="email"
                  label="Email Address"
                  prepend-inner-icon="mdi-email"
                  :rules="emailRules"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              text
              :disabled="!form"
              @click="finish"
              >Update</v-btn
            >
            <v-btn color="grey darken-1" text @click="cancel">Cancel</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
      <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>
    <v-snackbar v-model="snackbar">
      {{ snackbarMessage }}
      <v-btn text color="primary" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      loading: false,
      options: {
        color: 'primary',
        width: 500,
        zIndex: 200
      },
      email: '',
      snackbar: false,
      snackbarMessage: '',
      emailRules: [
        (v) => validateEmail(v) || 'E-Mail must be a valid e-mail format'
      ],
      form: false
    }
  },
  methods: {
    open(user) {
      this.dialog = true
      this.email = user.email1
    },
    async finish() {
      this.loading = true
      try {
        this.$root
          .$confirm({
            title: 'Update Email Address',
            message: `Are you sure you want to update your email address?`,
            confirmText: 'Yes'
          })
          .then(async () => {
            const success = await this.$store
              .dispatch('auth/updateEmailRequestAction', {
                email: this.email
              })
              .catch((err) => {
                this.snackbar = true
                this.snackbarMessage = err
                this.loading = false
              })
            if (success) {
              this.$root.$confirm({
                title: 'Update Email Address',
                message: `A confirmation has been sent to your email.`,
                reconfirmOnly: true,
                confirmText: 'OK',
                options: {
                  color: 'primary'
                }
              })
            }
          })
        this.dialog = false
        this.loading = false
      } catch (err) {
        this.snackbar = true
        this.snackbarMessage = err
        this.loading = false
      }
    },
    cancel() {
      this.dialog = false
    }
  }
}

function validateEmail(email) {
  //eslint-disable-next-line
  var re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}
</script>
